/* Code generated with AutoHTML Plugin for Figma */
import { Question } from "@project/shared-types";
import { useState } from "react";
import { Text } from "../../components/texts/text";
import { _sizeText } from "../../core/core";
import "./faq.css";
export const QuestionView: React.FC<{ question: Question | null }> = ({
  question = null,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenFirst, setIsOpenFirst] = useState(false);
  // Функция для получения карточек услуг с сервера
  // const fetchFaqClick = async () => {
  //   try {
  //     await apiFetch('api/faq/click/', { "question_id": question.id }); // Замените '/api/service-previews' на ваше API-оконечное точка для получения карточек услуг
  //     setIsOpenFirst(true)
  //   } catch (error) {
  //     console.error('Ошибка при получении карточек услуг:', error);
  //   }
  // };
  const toggleOpen = () => {
    setIsOpen(!isOpen);
    if (!isOpen && isOpenFirst == false) {
    }
  };
  if (!question) return null;
  return (
    <div key={question.id} onClick={toggleOpen} className="question">
      <div className="question-header">
        <Text size={_sizeText.xlb}>{question.title}</Text>

        <div className="question-icon">
          <svg
            className={isOpen ? "arrow-down  arrow-down-open" : "arrow-down"}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.07992 15.05L10.5999 8.53005C11.3699 7.76005 12.6299 7.76005 13.3999 8.53005L19.9199 15.05"
              stroke="#2C3135"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
      <div className={`question-body question-open-${isOpen}`}>
        <Text size={_sizeText.m}>{question.description}</Text>
      </div>
    </div>
  );
};
